import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Avatar, Grid, Button, Typography, Card, CardContent, CardActionArea, CardActions } from '@material-ui/core';
import { Link } from 'react-router-dom';
import links from 'utils/links';

const styles = theme => ({
  card: {
    minWidth: 300,
    textAlign: "center"
  },
  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover',
  },
  bigAvatar: {
    margin: 3,
    width: '70px',
    height: '70px',
    backgroundColor: '#d5d5d54a'
  },
  profileBtn: {
    backgroundColor: theme.palette.ternary.main,
    color: "white"
  },
  cardActions: {
    justifyContent: "center"
  }
});

function FollowerCard(props) {
  const { classes, data } = props;
  return (
    <Card className={classes.card}>
      <CardActionArea>
        <CardContent>
          <Grid container justify="center" alignItems="center">
            <Link to={links.contributorProfileLinks(data.id)}>
              <Avatar
                alt={data.displayName ? data.displayName : data.name}
                src={data.profilePic.uri ? data.profilePic.uri : '/icons/user.png'}
                className={classes.bigAvatar}
              />
            </Link>
          </Grid>
          <Typography gutterBottom variant="h6" component="h4">
            {data.displayName ? data.displayName : data.name}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.cardActions}>
        <Link to={links.contributorProfileLinks(data.id)}>
          <Button size="small" variant="outlined" color="secondary" className={classes.profileBtn}>
            View Profile
          </Button>
        </Link>
      </CardActions>
    </Card >
  );
}

FollowerCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FollowerCard);
